import { useState, FormEvent } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.currentTarget;
      const formDataToSend = new FormData(formElement);
      
      const response = await fetch('https://readdy.ai/api/form/d6mpcv85dsf7sr1n6eb0', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          projectType: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'serif' }}>
        Stuur ons een bericht
      </h2>
      <form id="contact-form" onSubmit={handleSubmit} data-readdy-form className="space-y-6">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-2">
            Naam *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none transition-all text-sm"
            placeholder="Uw naam"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-2">
            Email *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none transition-all text-sm"
            placeholder="uw.email@voorbeeld.nl"
          />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-2">
            Telefoon
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none transition-all text-sm"
            placeholder="+31 6 12345678"
          />
        </div>

        <div>
          <label htmlFor="projectType" className="block text-sm font-medium text-gray-900 mb-2">
            Type Project *
          </label>
          <select
            id="projectType"
            name="projectType"
            required
            value={formData.projectType}
            onChange={(e) => setFormData({ ...formData, projectType: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none transition-all text-sm cursor-pointer"
          >
            <option value="">Selecteer een optie</option>
            <option value="appartement">Appartement Renovatie</option>
            <option value="badkamer">Badkamer Verbouwing</option>
            <option value="keuken">Keuken Renovatie</option>
            <option value="complete">Complete Renovatie</option>
            <option value="anders">Anders</option>
          </select>
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-2">
            Bericht *
          </label>
          <textarea
            id="message"
            name="message"
            required
            rows={6}
            maxLength={500}
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none transition-all resize-none text-sm"
            placeholder="Vertel ons over uw project..."
          />
          <p className="text-xs text-gray-500 mt-1">
            {formData.message.length}/500 karakters
          </p>
        </div>

        {submitStatus === 'success' && (
          <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
            Bedankt voor uw bericht! We nemen zo snel mogelijk contact met u op.
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
            Er is iets misgegaan. Probeer het later opnieuw.
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-gray-900 text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
        >
          {isSubmitting ? 'Verzenden...' : 'Verstuur Bericht'}
        </button>

        <div className="relative flex items-center gap-3 my-2">
          <div className="flex-1 h-px bg-gray-200"></div>
          <span className="text-xs text-gray-400 font-medium">of</span>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        <a
          href="https://wa.me/3210231886?text=Hallo%2C%20ik%20heb%20een%20vraag%20over%20een%20renovatieproject."
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="w-full flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-[#1ebe5d] transition-colors whitespace-nowrap cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-whatsapp-line text-xl"></i>
          </div>
          Chat via WhatsApp
        </a>
      </form>
    </div>
  );
};

export default ContactForm;